// extracted by mini-css-extract-plugin
module.exports =  {"control":"zG94F9l"};